import { queryOptions, useQuery } from '@tanstack/react-query';

import API from '@api';

/**
 * Ссылка/QR на оплату заказа по СБП. Ответ одноразовый и завязан на статус
 * оплаты — не кэшируем повторные заходы (staleTime 0 по умолчанию).
 */
export const sbpLinkQueryOptions = (order: number) =>
  queryOptions({
    queryKey: ['sbpLink', order],
    queryFn: () => API.getSBPLink({ order }),
    select: res => res.getSBPLink
  });

export const useSbpLinkQuery = (order: number) =>
  useQuery({ ...sbpLinkQueryOptions(order), enabled: Number.isFinite(order) });
